<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header  ref="headerNav"/>
    <div class="content">
      <div class="headerbg">
        <span>网络模拟实训平台</span>
        <b>NETWORK SIMULATION TRAINING PLATFORM</b>
      </div>
      <div class="list">
        <ul>
          <li>自主探索</li>
          <li>体验教学</li>
          <li>竞争挑战</li>
          <li>仿真实战</li>
        </ul>
        <p>
创业环境分析、组建高效团队、激发创新思维、把握创业商机、企业开办准备、模拟经营管理、创业质量评估、形成创业
计划        </p>
      </div>
      <div class="bgbox">
        <div class="setion">
          <div class="left">
            <p>创业环境分析</p>
            <div class="line"></div>
            <div class="text">
              创业环境分析分为国家创业政策、省市创业政策、创业法律法规。为创业者提供方向性政策指导。创业环境分析实现政策法规平台共享。
            </div>
          </div>
          <div class="right">
            <img
            style="width:400px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Network simulation training/img1.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="bgbox">
        <div class="setion">
          <div class="right">
            <img
            style="width:408px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Network simulation training/img2.png"
              alt=""
            />
          </div>
          <div class="left">
            <p>激发创新思维</p>
            <div class="line"></div>
            <div class="text">
             激发创新思维分为树立创新意识、培养创新思维、开启创业想象力。内置头脑风暴、创新思考六顶帽等创新工具，实现在线智能分组。
            </div>
          </div>
        </div>
      </div>

      <div class="bgbox">
        <div class="setion">
          <div class="left">
            <p>组建高效团队</p>
            <div class="line"></div>
            <div class="text">
              组建高效团队分为创新创业测评、创新创业学院、创新创业案例分析。创新创业测评涵盖创新和创业双重维度的测评模块，包含四大维度三十三大测评项，内置海量测评试题。
            </div>
          </div>
          <div class="right">
            <img
            style="width:400px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Network simulation training/img3.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="bgbox">
        <div class="setion">
          <div class="right">
            <img
            style="width:500px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Network simulation training/img4.png"
              alt=""
            />
          </div>
          <div class="left">
            <p>把握创业商机</p>
            <div class="line"></div>
            <div class="text">
             把握创业商机分为商业画布、项目路演。新增项目路演大厅，实现在线文稿同步动态路演功能。
            </div>
          </div>
        </div>
      </div>

       <div class="bgbox">
        <div class="setion">
          <div class="left">
            <p>企业开办准备</p>
            <div class="line"></div>
            <div class="text">
              企业开办准备涵盖企业设立的全过程，更新至五证合一。跟政策，实现五证合一。
            </div>
          </div>
          <div class="right">
            <img
            style="width:400px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Network simulation training/img5.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="bgbox">
        <div class="setion">
          <div class="right">
            <img
            style="width:400px"
             src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Network simulation training/img6.png"
              alt=""
            />
          </div>
          <div class="left">
            <p>模拟经营管理</p>
            <div class="line"></div>
            <div class="text">
             模拟经营管理模块仿真模拟初创无人机高科技行业，
模拟企业总裁办、营销运营部、人事行政部、财务部、研发采购部、情报室及连锁体验店等多个企业只能部门场景。角色扮演，创业经营管理能力训练
            </div>
          </div>
        </div>
      </div>

       <div class="bgbox">
        <div class="setion">
          <div class="left">
            <p>创业质量评估</p>
            <div class="line"></div>
            <div class="text">
              创业质量评估模块分为选取创业要素、设置数列参数、对比创业关联度、创业评估结果分析。数据统计，指标分析，指导创就业方向。
            </div>
          </div>
          <div class="right">
            <img
            style="width:518px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Network simulation training/img7.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="bgbox">
        <div class="setion">
          <div class="right">
            <img
            style="width:542px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Network simulation training/img8.png"
              alt=""
            />
          </div>
          <div class="left">
            <p>形成创业计划</p>
            <div class="line"></div>
            <div class="text">
             形成创业计划分为创业计划书范本、创业计划书模板、撰写计划书、教师评价与得分。分模块训练，逐个击破，实现在线文档预览。
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'NetworkSimulation',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
      // console.log('eeeeeeeee', e.srcElement.scrollTop, e.target.scrollTop)
    },
  }

}
</script>

<style lang="scss" scoped>
.setion {
  margin: 0 auto;
  display: flex;
  width: 1200px;
  padding-top: 80px;
  padding-bottom: 80px;
  // background-color: rgb(35, 135, 228);

  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    p {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .line {
      margin-top: 20px;
      width: 120px;
      height: 4px;
      background: #f39a21;
    }
    .text {
      width: 468px;
      margin-top: 60px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
       line-height: 1.8;
    }
  }
  .right {
    flex: 1;
  }
}
.bgbox {
  width: 100%;
}
.bgbox:nth-child(2n){
background: #f8f8f8;
.left {
  padding-left: 140px;
}
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
  .content {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .headerbg {
      width: 100%;
      height: 580px;
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Network simulation training/headerbg.png");
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      span {
        font-size: 42px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
      b {
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #006cda;
      }
    }
    .list {
      width: 100%;
      height: 243px;
      background: #f8f8f8;
    }
    .list > ul {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      li {
        list-style: none;
        height: 43px;
        text-align: center;
        width: 300px;
        border-right: 1px solid #999999;
        line-height: 43px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      li:nth-child(4) {
        border-right: none;
      }
    }
    .list p {
      margin: 0 auto;
      text-align: center;
      width: 1067px;
      margin-top: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Network-simulation.vue